import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";
import Navbar from "../components/Navbar";
import "../css/ManageShipping.css";
import toast from "react-hot-toast";

function ManageShipping() {
  const [shippingAreas, setShippingAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingArea, setEditingArea] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    isActive: true,
  });

  useEffect(() => {
    fetchShippingAreas();
  }, []);

  const fetchShippingAreas = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "shippingAreas"));
      const areasData = [];
      querySnapshot.forEach((doc) => {
        areasData.push({ id: doc.id, ...doc.data() });
      });
      // Sort by name
      areasData.sort((a, b) => a.name.localeCompare(b.name, "ar"));
      setShippingAreas(areasData);
    } catch (error) {
      console.error("Error fetching shipping areas:", error);
      toast.error("حدث خطأ أثناء تحميل مناطق الشحن");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate price
    const price = parseFloat(formData.price);
    if (isNaN(price) || price < 0) {
      toast.error("يرجى إدخال سعر صحيح");
      return;
    }

    try {
      const areaData = {
        name: formData.name.trim(),
        price: price,
        isActive: formData.isActive,
        updatedAt: new Date(),
      };

      if (editingArea) {
        // Update existing area
        await updateDoc(doc(db, "shippingAreas", editingArea.id), areaData);
        toast.success("تم تحديث منطقة الشحن بنجاح");
      } else {
        // Add new area
        areaData.createdAt = new Date();
        await addDoc(collection(db, "shippingAreas"), areaData);
        toast.success("تم إضافة منطقة الشحن بنجاح");
      }

      fetchShippingAreas();
      closeModal();
    } catch (error) {
      console.error("Error saving shipping area:", error);
      toast.error("حدث خطأ أثناء حفظ منطقة الشحن");
    }
  };

  const handleEdit = (area) => {
    setEditingArea(area);
    setFormData({
      name: area.name || "",
      price: area.price || "",
      isActive: area.isActive !== false,
    });
    setShowModal(true);
  };

  const handleDelete = async (area) => {
    toast(
      (t) => (
        <div style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "12px", fontWeight: "600" }}>
            هل أنت متأكد من حذف منطقة الشحن "{area.name}"؟
          </p>
          <p style={{ marginBottom: "16px", fontSize: "0.9em", color: "#666" }}>
            هذا الإجراء لا يمكن التراجع عنه
          </p>
          <div
            style={{ display: "flex", gap: "8px", justifyContent: "center" }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
              }}
              style={{
                padding: "8px 16px",
                background: "#e5e7eb",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "600",
              }}
            >
              إلغاء
            </button>
            <button
              onClick={async () => {
                toast.dismiss(t.id);
                try {
                  await deleteDoc(doc(db, "shippingAreas", area.id));
                  toast.success("تم حذف منطقة الشحن بنجاح");
                  fetchShippingAreas();
                } catch (error) {
                  console.error("Error deleting shipping area:", error);
                  toast.error("حدث خطأ أثناء حذف منطقة الشحن");
                }
              }}
              style={{
                padding: "8px 16px",
                background: "#ef4444",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontFamily: "Cairo, sans-serif",
                fontWeight: "600",
              }}
            >
              حذف
            </button>
          </div>
        </div>
      ),
      {
        duration: 6000,
        style: {
          minWidth: "300px",
        },
      },
    );
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingArea(null);
    setFormData({
      name: "",
      price: "",
      isActive: true,
    });
  };

  return (
    <>
      <Navbar />
      <div className="manage-shipping">
        <div className="msh-header">
          <h1>إدارة مناطق الشحن</h1>
          <button
            className="msh-btn primary"
            onClick={() => setShowModal(true)}
          >
            + إضافة منطقة جديدة
          </button>
        </div>

        {loading ? (
          <div className="msh-loading">
            <div className="spinner"></div>
            <p>جاري التحميل...</p>
          </div>
        ) : (
          <div className="msh-areas-grid">
            {shippingAreas.map((area) => (
              <div
                key={area.id}
                className={`msh-area-card ${!area.isActive ? "inactive" : ""}`}
              >
                <div className="msh-area-header">
                  <h3>{area.name}</h3>
                  {!area.isActive && (
                    <span className="msh-inactive-badge">غير نشط</span>
                  )}
                </div>
                <div className="msh-area-price">
                  <span className="msh-price-label">سعر الشحن:</span>
                  <span className="msh-price-value">{area.price} ₪</span>
                </div>
                <div className="msh-area-actions">
                  <button
                    className="msh-btn edit"
                    onClick={() => handleEdit(area)}
                  >
                    <i className="fas fa-edit"></i> تعديل
                  </button>
                  <button
                    className="msh-btn delete"
                    onClick={() => handleDelete(area)}
                  >
                    <i className="fas fa-trash-alt"></i> حذف
                  </button>
                </div>
              </div>
            ))}
            {shippingAreas.length === 0 && (
              <div className="msh-empty">
                <i className="fas fa-shipping-fast"></i>
                <p>لا توجد مناطق شحن. قم بإضافة منطقة جديدة للبدء.</p>
              </div>
            )}
          </div>
        )}

        {showModal && (
          <div className="msh-modal-overlay" onClick={closeModal}>
            <div className="msh-modal" onClick={(e) => e.stopPropagation()}>
              <div className="msh-modal-header">
                <h2>
                  {editingArea ? "تعديل منطقة الشحن" : "إضافة منطقة شحن جديدة"}
                </h2>
                <button className="msh-close-btn" onClick={closeModal}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <form onSubmit={handleSubmit} className="msh-form">
                <div className="msh-form-group">
                  <label>اسم المنطقة *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="مثال: الضفة الغربية"
                  />
                </div>

                <div className="msh-form-group">
                  <label>سعر الشحن (₪) *</label>
                  <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                    min="0"
                    step="0.01"
                    placeholder="مثال: 20"
                  />
                </div>

                <div className="msh-form-group">
                  <label className="msh-checkbox-label">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={formData.isActive}
                      onChange={handleInputChange}
                    />
                    <span>المنطقة نشطة</span>
                  </label>
                </div>

                <div className="msh-form-actions">
                  <button
                    type="button"
                    className="msh-btn"
                    onClick={closeModal}
                  >
                    إلغاء
                  </button>
                  <button type="submit" className="msh-btn primary">
                    {editingArea ? "تحديث" : "إضافة"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ManageShipping;
